import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import Container from "@material-ui/core/Container";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useLocation } from "react-router-dom";
import {
  deleteInvoice,
  filterInvoices,
  getInvoicesByClient,
  getInvoicesByUser,
} from "../../actions/invoiceActions";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import { useMediaQuery } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import InvoicePdfGenerator from "./InvoicePdfGenerator";
import { formateDate } from "../../utils/utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const inputStyle = {
  padding: "0.75rem 0.75rem",
  width: "50%",
  fontSize: "0.8rem",
  lineHeight: 1.25,
  color: "#55595c",
  backgroundColor: "#fff",
  backgroundImage: "none",
  backgroundClip: "padding-box",
  borderTop: "0",
  borderRight: "0",
  borderBottom: "1px solid #eee",
  borderLeft: "0",
  borderRadius: "3px",
  transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
};
const iconStyle = {
  fontSize: "1.5rem",
  marginRight: "8px",
  position: "absolute",
  right: "50%",
  top: 10,
};

const filterStyle = {
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  width: "100%",
};
const totalsStyle = {
  display: "flex",
  flexDirection: "column",
  color: "#23232E",
};

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "8px",
  textAlign: "center",
};
const headerStyle = { borderBottom: "none", textAlign: "center" };

const ClientInvoices = () => {
  const [selectedFromDate, handleFromDateChange] = useState(null);
  const [selectedToDate, handleToDateChange] = useState(null);
  const isMobile = useMediaQuery("(max-width: 600px)"); // Define your mobile breakpoint here

  if (isMobile) {
    inputStyle.width = "100%";
    iconStyle.right = 0;
  }
  // filter invoce

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const filter = searchParams.get("filter");
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const invoices = useSelector((state) => state.invoices.invoices);
  console.log(invoices);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const rows = invoices
    .filter((invoice) => {
      return invoice?.client?._id === searchParams.get("id");
    })
    .filter(
      (invoice) =>
        invoice?.client?.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        invoice.invoiceNumber.includes(searchTerm)
    );
  const total = rows
    .reduce((accumulator, currentItem) => {
      return accumulator + currentItem.total;
    }, 0)
    .toFixed(2);

  const totalPaid = rows
    .filter((e) => e.status !== "Unpaid")
    .reduce((accumulator, currentItem) => {
      return accumulator + currentItem.totalAmountReceived;
    }, 0)
    .toFixed(2);

  const handleFilter = () => {
    if (
      selectedFromDate <= selectedToDate &&
      selectedFromDate !== null &&
      format(selectedToDate, "yyyy-MM-dd") <= format(new Date(), "yyyy-MM-dd")
    ) {
      dispatch(
        filterInvoices({
          from: format(selectedFromDate, "yyyy-MM-dd"),
          to: format(selectedToDate, "yyyy-MM-dd"),
          search: user?.result?._id || user?.result?.googleId,
        })
      );
    } else {
      openSnackbar("Please select the correct date.");
    }
  };
  // const rows = []

  // useEffect(() => {
  //     dispatch(getInvoices());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getInvoicesByClient(searchParams.get("id")));
    // eslint-disable-next-line
  }, [location, searchParams.get("id")]);

  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`);
  };

  if (!user) {
    history.push("/login");
  }

  function checkStatus(status) {
    return status === "Partial"
      ? {
          border: "solid 0px #1976d2",
          backgroundColor: "#baddff",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : status === "Paid"
      ? {
          border: "solid 0px green",
          backgroundColor: "#a5ffcd",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : status === "Unpaid"
      ? {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : "red";
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          padding: "20px",
          margin: "80px",
        }}
      >
        <Container
          style={{
            width: "100%",

            paddingBottom: "20px",

            border: "none",
          }}
        >
          <h4>Filter with date :</h4>
          <div style={filterStyle}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                label="From"
                value={selectedFromDate}
                onChange={(date) => handleFromDateChange(date)}
              />
              <DatePicker
                label="To"
                value={selectedToDate}
                onChange={(date) => handleToDateChange(date)}
              />
              <Button
                variant="contained"
                style={{ justifyContentContent: "center" }}
                type="submit"
                color="primary"
                onClick={() => handleFilter()}
              >
                Filter
              </Button>
            </MuiPickersUtilsProvider>
          </div>
        </Container>

        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No invoice yet. Click the plus icon to create invoice
        </p>
      </div>
    );
  }
  const handleDelte = (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this invoice?"
    );

    if (confirmed) {
      dispatch(deleteInvoice(id, openSnackbar));
    }
  };
  return (
    <div>
      <Container
        style={{
          width: "85%",
          paddingTop: "70px",
          paddingBottom: "50px",
          border: "none",
        }}
      >
        {filter === "customer" ? (
          <Container
            style={{
              width: "100%",
              paddingTop: "70px",
              paddingBottom: "50px",
              border: "none",
            }}
          >
            <h2>Client Details :</h2>
            <p>Name: {searchParams.get("name") || "---"}</p>
            <p>Email: {searchParams.get("email") || "---"}</p>
            <p>Phone: {searchParams.get("phone") || "---"}</p>
            <p>Address: {searchParams.get("address") || "---"}</p>
            <p>
              Birthday: {formateDate(searchParams.get("birthday")) || "---"}
            </p>
            <p>Father name: {searchParams.get("fatherFullName") || "---"}</p>
            <p>Father phone: {searchParams.get("fatherPhone") || "---"}</p>
            <p>Mother name: {searchParams.get("motherFullName") || "---"}</p>
            <p>Mother phone: {searchParams.get("motherPhone") || "---"}</p>
          </Container>
        ) : (
          <Container
            style={{
              width: "100%",

              paddingBottom: "20px",
              marginLeft: "-20px",
              border: "none",
            }}
          >
            <div style={filterStyle}>
              <input
                placeholder="Search with client name or ID..."
                name="search"
                type="text"
                style={inputStyle}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <SearchRoundedIcon style={iconStyle} />
            </div>
          </Container>
        )}
        {user?.result?.role !== "assistant" && (
          <Container
            style={{
              width: "100%",

              paddingBottom: "20px",

              border: "none",
            }}
          >
            <h4>Filter with date :</h4>
            <div style={filterStyle}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  label="From"
                  value={selectedFromDate}
                  onChange={(date) => handleFromDateChange(date)}
                />
                <DatePicker
                  label="To"
                  value={selectedToDate}
                  onChange={(date) => handleToDateChange(date)}
                />
                <Button
                  variant="contained"
                  style={{ justifyContentContent: "center" }}
                  type="submit"
                  color="primary"
                  onClick={() => handleFilter()}
                >
                  Filter
                </Button>
              </MuiPickersUtilsProvider>
            </div>
          </Container>
        )}

        <TableContainer component={Paper} elevation={0}>
          <Table className={classes.table} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell style={headerStyle}>Number</TableCell>
                <TableCell style={headerStyle}>Client</TableCell>
                <TableCell style={headerStyle}>Amount</TableCell>
                <TableCell style={headerStyle}>Due Date</TableCell>
                <TableCell style={headerStyle}>Status</TableCell>
                <TableCell style={headerStyle}>Edit</TableCell>
                <TableCell style={headerStyle}>Delete</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : rows
              ).map((row) => (
                <TableRow key={row._id} style={{ cursor: "pointer" }}>
                  <TableCell
                    style={tableStyle}
                    onClick={() => openInvoice(row._id)}
                  >
                    {" "}
                    {row.invoiceNumber}{" "}
                  </TableCell>
                  <TableCell
                    style={tableStyle}
                    onClick={() => openInvoice(row._id)}
                  >
                    {" "}
                    {row?.client?.name}{" "}
                  </TableCell>
                  <TableCell
                    style={tableStyle}
                    onClick={() => openInvoice(row._id)}
                  >
                    {row.currency} {row.total ? toCommas(row.total) : row.total}{" "}
                  </TableCell>
                  <TableCell
                    style={tableStyle}
                    onClick={() => openInvoice(row._id)}
                  >
                    {" "}
                    {moment(row.dueDate).fromNow()}{" "}
                  </TableCell>
                  <TableCell
                    style={tableStyle}
                    onClick={() => openInvoice(row._id)}
                  >
                    {" "}
                    <button style={checkStatus(row.status)}>
                      {row.status}
                    </button>
                  </TableCell>

                  <TableCell style={{ ...tableStyle, width: "10px" }}>
                    <IconButton onClick={() => editInvoice(row._id)}>
                      <BorderColorIcon
                        style={{ width: "20px", height: "20px" }}
                      />
                    </IconButton>
                  </TableCell>
                  <TableCell style={{ ...tableStyle, width: "10px" }}>
                    <IconButton onClick={() => handleDelte(row._id)}>
                      <DeleteOutlineRoundedIcon
                        style={{ width: "20px", height: "20px" }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
        <Container
          style={{
            width: "100%",

            border: "none",
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
            color: "#23232E",
          }}
        >
          <div style={totalsStyle}>
            <h3>
              Total Amount : {total} {invoices[0].currency}
            </h3>
            <h3>
              Total Amount Recived : {totalPaid} {invoices[0].currency}
            </h3>
            <h3>
              Total Amount Unpaid: {(total - totalPaid).toFixed(2)}{" "}
              {invoices[0].currency}
            </h3>
          </div>
        </Container>
        <InvoicePdfGenerator invoices={rows} name={user?.result?.name} />
      </Container>
    </div>
  );
};

export default ClientInvoices;
